module.exports = __webpack_public_path__ + "img/0Q3A5767_L_WoodMatted_MockedUp.0362820e.jpg";